import React from "react";
// import NoteAltIcon from '@mui/icons-material/NoteAlt';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
function Header() {
  return (
    <header>

      <h1>
          <TextSnippetIcon />
          Diary Note
      </h1>
    </header>
  );
}

export default Header;
